import { createContext } from 'react';

export const LaboratoryDocumentsContext = createContext();
